window.io = require('socket.io-client');
import Echo from 'laravel-echo';

window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: process.env.VUE_APP_SOCKET_URL + ':' + process.env.VUE_APP_SOCKET_PORT,
});
